import { useDispatch, useSelector } from 'react-redux';
import { TreeRule } from "../Rules/TreeRule";
import { TreeSearch } from "../Rules/TreeSearch";

const LeftContent = () => {
  const ruleTab = useSelector( state => state.rules.ruleTab);

  return (
  <div className="h-screen overflow-y-auto p-2">
    { ruleTab === 'search' && <TreeSearch /> }
    { ruleTab === 'rule' && <TreeRule /> }
    <div className="h-[128px]"></div>
  </div>
  )
};

export default LeftContent;